"use strict";
var hlp = require('common/helpers');
var Menu = require('../helpers/menu');
var MENUENTRIES = require('../helpers/menuentries');
var fieldEntryCtrl = function($scope, $uibModal, $sce, $http) {
  var init = function() {
    initMenu();
  };
  var initMenu = function() {
    var menu = new Menu();
    var group = null;
    if ($scope.schema.type == 'enum') {
      group = menu.createGroup();
      var $__1 = function() {
        var value = $scope.schema.values[i];
        group.addItem({
          title: value.name,
          icon: "fa-circle-o"
        }, function() {
          setEnum($scope.entry, value.value);
          menu.calcShow();
        }, function() {
          if ($scope.entry.value == value.value) {
            return false;
          }
          return true;
        });
        group.addItem({
          title: value.name,
          icon: "fa-check-circle-o"
        }, function() {
          setEnum($scope.entry, value.value);
          menu.calcShow();
        }, function() {
          if ($scope.entry.value == value.value) {
            return true;
          }
          return false;
        });
      };
      for (var i = 0; i < $scope.schema.values.length; i++) {
        $__1();
      }
    }
    group = menu.createGroup();
    if ($scope.schema.multiple) {
      group.addItem(MENUENTRIES.add, function() {
        $scope.addEntry();
      }, true);
      group.addItem(MENUENTRIES.remove, function() {
        $scope.removeEntry($scope.entry);
      }, true);
    }
    group = menu.createGroup();
    if ($scope.schema.thesaurus) {
      group.addItem(MENUENTRIES.thesaurus, $scope.showThesaurus, true);
    }
    if ($scope.schema.comments) {
      group.addItem(MENUENTRIES.comments, $scope.showComments, true);
    }
    if ($scope.schema.references) {
      group.addItem(MENUENTRIES.references, $scope.showReferences, true);
    }
    if ($scope.schema.lodEntries) {
      group.addItem(MENUENTRIES.lodentries, $scope.showLodEntries, true);
    }
    if (hlp.isSet($scope.schema.flags)) {
      group = menu.createGroup();
      if ($scope.schema.flags.remarkable) {
        group.addItem(MENUENTRIES.remarkable, function() {
          $scope.toggleFlag($scope.entry, 'remarkable');
        }, true);
      }
      if ($scope.schema.flags.unconfirmed) {
        group.addItem(MENUENTRIES.unconfirmed, function() {
          $scope.toggleFlag($scope.entry, 'unconfirmed');
        }, true);
      }
    }
    menu.calcShow();
    $scope.menu = menu;
  };
  var setEnum = function(entry, value) {
    entry.value = value;
  };
  init();
};
fieldEntryCtrl.$inject = ['$scope', '$uibModal', '$sce', '$http'];
module.exports = fieldEntryCtrl;
